import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import unserialize from './unserialize';
import style from "./Components/TraceLine.css";
import { formatArgument } from "./Components/TraceLine";
window.unserialize = unserialize;
export var ExceptionParser =
/*#__PURE__*/
function () {
  function ExceptionParser() {
    _classCallCheck(this, ExceptionParser);
  }

  _createClass(ExceptionParser, [{
    key: "isException",
    value: function isException(logMessage) {
      return this.isNewStyleException(logMessage) || this.isOldStyleException(logMessage) || this.isBackgroundJobException(logMessage);
    }
  }, {
    key: "isNewStyleException",
    value: function isNewStyleException(logMessage) {
      return logMessage.Exception;
    }
  }, {
    key: "isOldStyleException",
    value: function isOldStyleException(logMessage) {
      return logMessage.substr && logMessage.substr(0, 12) === 'Exception: {';
    }
  }, {
    key: "isBackgroundJobException",
    value: function isBackgroundJobException(logMessage) {
      return logMessage.substr && logMessage.substr(0, 34) === 'Error while running background job' && logMessage.indexOf('{"Exception":') !== -1;
    }
  }, {
    key: "parse",
    value: function parse(logMessage) {
      if (this.isNewStyleException(logMessage)) {
        return logMessage;
      }

      var data;

      if (this.isOldStyleException(logMessage)) {
        try {
          data = this.tryParseJSON(logMessage.substr(10));
        } catch (e) {
          console.log('Error while parsing exception:');
          console.log(logMessage.substr(10));
          console.error(e);
        }
      } else {
        data = this.tryParseJSON(logMessage.substr(logMessage.indexOf('{"Exception":')));
        var messageHead = logMessage.substr(0, logMessage.indexOf('{"Exception":'));
        var jobDataString = messageHead.split('(', 2)[1];
        var jobDataParts = jobDataString.split(',', 2).map(function (part) {
          return part.trim();
        });
        data.jobClass = jobDataParts[0].split(':', 2)[1].trim();
        data.jobArguments = jobDataParts[1].substr(10).trim();
        window.s = jobDataParts[1].substr(10).trim();

        if (data.jobClass === 'OC\\Command\\CommandJob') {
          try {
            var _this$parseCommandJob = this.parseCommandJob(data.jobArguments);

            var _this$parseCommandJob2 = _slicedToArray(_this$parseCommandJob, 2);

            data.jobClass = _this$parseCommandJob2[0];
            data.jobArguments = _this$parseCommandJob2[1];
          } catch (e) {}
        }
      }

      var traceLines = data.Trace.split('\n');
      data.Trace = traceLines.map(this.parseTraceLine);
      return data;
    }
  }, {
    key: "tryParseJSON",
    value: function tryParseJSON(json) {
      try {
        return JSON.parse(json);
      } catch (e) {
        // fix unescaped newlines
        json = json.replace(/\n/g, '\\n'); // fix unescaped namespace delimiters

        json = json.replace(/([^\\])\\([A-Z{])/g, '$1\\\\$2');

        try {
          return JSON.parse(json);
        } catch (e) {
          console.log('Error while parsing exception:');
          console.log(json);
          console.error(e);
        }
      }
    }
  }, {
    key: "parseCommandJob",
    value: function parseCommandJob(data) {
      var parsed = unserialize(data);
      return [parsed['class'], parsed.properties];
    }
  }, {
    key: "parseTraceLine",
    value: function parseTraceLine(line) {
      var parts = line.split(' ');
      var number = parts.shift();
      var traceData = parts.join(' ');
      parts = traceData.split(':');

      if (parts.length > 1) {
        var file, lineNumber;
        var fileAndLine = parts.shift();
        var call = parts.join(' ');

        if (fileAndLine[0] === '[') {
          lineNumber = false;
          file = fileAndLine;
        } else {
          var filePaths = fileAndLine.split('(', 2);
          file = filePaths[0];
          lineNumber = filePaths[1].substr(0, filePaths[1].length - 1);
        }

        return {
          'function': call,
          number: number,
          file: file,
          line: lineNumber
        };
      } else {
        return {
          'function': traceData,
          number: number,
          file: false,
          line: false
        };
      }
    }
  }, {
    key: "format",
    value: function format(logMessage) {
      if (!this.isException(logMessage)) {
        return logMessage;
      }

      var parsed = this.parse(logMessage);

      var fileAndLine = function fileAndLine(item) {
        if (item.file && item.line) {
          return "".concat(item.file, " line ").concat(item.line);
        } else {
          return '<<closure>>';
        }
      };

      if (parsed.Exception) {
        var widestIndex = ('' + (parsed.Trace.length - 1)).length;
        var message = "".concat(parsed.Exception, ": ").concat(parsed.Message, " at ").concat(fileAndLine(parsed), "\n\n");
        message += parsed.Trace.map(function (trace, i) {
          var args = trace.args.map(function (arg) {
            var baseFormatted = formatArgument(arg, 0).replace(/\n/g, '');
            ;
            var showInline = baseFormatted.length < 42;
            return showInline ? baseFormatted : "".concat(baseFormatted.substr(0, 16), " ... ").concat(baseFormatted.substr(baseFormatted.length - 2, 2));
          });
          return "".concat(' '.repeat(widestIndex - ('' + i).length)).concat(i, ". ").concat(fileAndLine(trace), "\n") + "".concat(' '.repeat(widestIndex + 2)).concat(trace.class).concat(trace.type).concat(trace.function, "(").concat(args.join(', '), ")");
        }).join('\n');
        return message;
      } else {
        return parsed;
      }
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ExceptionParser;
}();
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ExceptionParser, "ExceptionParser", "/srv/http/owncloud/apps/logreader/js/ExceptionParser.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();